import React, { useEffect } from 'react';
import { Loader2, X } from 'lucide-react';

import { Button } from '../../ui/button';

// Minimal confirm dialog shared across the Billing area (ReferralPayouts
// modal recipe).
const ConfirmModal = ({
  title,
  body,
  confirmLabel,
  destructive,
  confirmClassName,
  confirmDisabled = false,
  onClose,
  onConfirm,
  isSaving,
}) => {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[1060] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute inset-0 bg-black/50" onClick={onClose} aria-hidden="true" />
      <div className="relative z-10 w-full max-w-md rounded-xl border border-border bg-card shadow-lg">
        <div className="flex items-center justify-between border-b border-border px-4 py-2.5">
          <h3 className="mb-0 text-base font-semibold text-foreground">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md p-1 text-muted-foreground hover:bg-accent hover:text-foreground"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="space-y-5 px-4 py-4">
          <div className="mb-0 text-sm leading-relaxed text-foreground">{body}</div>
          <div className="flex justify-end gap-2">
            <Button size="sm" variant="secondary" onClick={onClose} disabled={isSaving}>
              Cancel
            </Button>
            <Button
              size="sm"
              variant={destructive ? 'destructive' : 'default'}
              className={confirmClassName}
              onClick={onConfirm}
              disabled={isSaving || confirmDisabled}
            >
              {isSaving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              {confirmLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
